import { zmdiToMuiIconMap } from './iconMapper';
import AppsIcon from '@mui/icons-material/Apps'; // Fallback / Default

export const iconMap = zmdiToMuiIconMap;

export const getMenuIcon = (zmdiClass, props = {}) => {
  if (!zmdiClass) {
    return <AppsIcon {...props} />;
  }

  const cleanClass = zmdiClass.trim();
  const IconComponent = iconMap[cleanClass] || AppsIcon;

  return <IconComponent {...props} />;
};

export default iconMap;
